import ProductDatasetSource from '~/Api/Product/ProductDatasetSource';

import DatasetExtension from './DatasetExtension';

export default class Dataset {
	source: ProductDatasetSource;

	description: string | null;

	productRetrievedAt: Date | null;

	productUrl: string | null;

	validFrom: Date | null;

	rawData: { [key: string]: any };

	productUpdatedAt: Date | null;

	extensions: DatasetExtension[];

	constructor(
		source: ProductDatasetSource,
		description: string | null,
		productRetrievedAt: Date | null,
		productUrl: string | null,
		validFrom: Date | null,
		rawData: { [key: string]: any },
		productUpdatedAt: Date | null,
		extensions: DatasetExtension[]
	) {
		this.source = source;
		this.description = description;
		this.productRetrievedAt = productRetrievedAt;
		this.productUrl = productUrl;
		this.validFrom = validFrom;
		this.rawData = rawData;
		this.productUpdatedAt = productUpdatedAt;
		this.extensions = extensions;
	}
}
